import React from "react";
import { motion } from "framer-motion";

/**
 * Logo mark — stylized turquoise globe with an airplane arc.
 * Uses inline SVG for crispness at any size.
 */
export const LogoMark = ({ size = 40, tone = "light" }) => {
  const ink = tone === "light" ? "#F5F1E8" : "#0B1416";
  const turq = "#1BB6B9";
  const glow = "#6EE3E6";

  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial={{ rotate: -6 }}
      animate={{ rotate: 0 }}
      transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      style={{ overflow: "visible" }}
    >
      {/* Globe */}
      <circle cx="32" cy="32" r="22" stroke={ink} strokeWidth="1.4" />
      {/* Meridians */}
      <ellipse cx="32" cy="32" rx="22" ry="9" stroke={ink} strokeWidth="1" opacity="0.7" />
      <ellipse cx="32" cy="32" rx="9" ry="22" stroke={ink} strokeWidth="1" opacity="0.7" />
      {/* Continents dot */}
      <circle cx="24" cy="27" r="2" fill={turq} />
      <circle cx="40" cy="36" r="1.6" fill={turq} opacity="0.7" />
      {/* Orbital dashed arc */}
      <motion.circle
        cx="32"
        cy="32"
        r="28"
        stroke={glow}
        strokeWidth="1"
        strokeDasharray="2 4"
        opacity="0.55"
        animate={{ rotate: 360 }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
        style={{ transformOrigin: "32px 32px" }}
      />
      {/* Airplane */}
      <g transform="rotate(-35 32 32) translate(0 -30)">
        <path
          d="M32 24 L34 30 L44 32 L34 34 L32 40 L30 34 L20 32 L30 30 Z"
          fill={turq}
          stroke={ink}
          strokeWidth="0.6"
          strokeLinejoin="round"
        />
      </g>
    </motion.svg>
  );
};

export const LogoWordmark = ({ tone = "light" }) => {
  const ink = tone === "light" ? "text-[#F5F1E8]" : "text-[#0B1416]";
  return (
    <div className="flex items-center gap-3">
      <LogoMark size={38} tone={tone} />
      <div className={`leading-none ${ink}`}>
        <div className="font-heading text-[22px] tracking-tight">Travel To Time</div>
        <div className="overline opacity-60 mt-1" style={{ fontSize: 9 }}>
          Mataró · Barcelona
        </div>
      </div>
    </div>
  );
};
